import { render, staticRenderFns } from "./UVInteractive.vue?vue&type=template&id=eee16c24&scoped=true"
import script from "./UVInteractive.vue?vue&type=script&lang=ts"
export * from "./UVInteractive.vue?vue&type=script&lang=ts"
import style0 from "./UVInteractive.vue?vue&type=style&index=0&id=eee16c24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee16c24",
  null
  
)

export default component.exports